import React from 'react';
import styles from './Landing.scss';
import manualWeb from '../../assets/pdf/user-manual-web.pdf';
import manualMobile from '../../assets/pdf/user-manual-mobile.pdf';

const AboutProject = () => (
  <div className={styles.Landing}>
    <h1>О ПРОЕКТЕ</h1>

    <p>
      Общество с ограниченной ответственностью «Недвекс» осуществляет деятельность в области
      информационных технологий: разрабатывает и эксплуатирует программное обеспечение для
      автоматизации работы с объектами недвижимости.
    </p>

    <hr />

    <h2>1. Сведения о правообладателе</h2>

    <table>
      <tbody>
        <tr>
          <td>Полное наименование</td>
          <td>Общество с ограниченной ответственностью «Недвекс»</td>
        </tr>
        <tr>
          <td>ИНН</td>
          <td>2318043183</td>
        </tr>
        <tr>
          <td>КПП</td>
          <td>231801001</td>
        </tr>
        <tr>
          <td>ОГРН</td>
          <td>1162366056830</td>
        </tr>
        <tr>
          <td>ОКВЭД</td>
          <td>63.11 — Деятельность по обработке данных, предоставление услуг по размещению информации</td>
        </tr>
        <tr>
          <td>Коды ИТ-деятельности (приказ Минцифры № 449)</td>
          <td>62.01.2, 62.01.29, 58.29.2, 58.29.3, 58.29.4</td>
        </tr>
        <tr>
          <td>Юридический адрес</td>
          <td>354207, Краснодарский край, г. Сочи, Лазаревский район, ул. Летняя, стр. 15/2</td>
        </tr>
        <tr>
          <td>Email</td>
          <td><a href="mailto:content@nedvexapp.ru">content@nedvexapp.ru</a></td>
        </tr>
        <tr>
          <td>Телефон</td>
          <td><a href="tel:+79683000112">+7 (968) 300-01-12</a></td>
        </tr>
      </tbody>
    </table>

    <hr />

    <h2>2. Сведения об исключительных правах на ПО</h2>

    <p>
      Исключительные права на программное обеспечение «Nedvex App» и базу данных «Nedvex App» на
      территории Российской Федерации принадлежат ООО «Недвекс» на основании собственной разработки.
      Права зарегистрированы в Федеральной службе по интеллектуальной собственности (Роспатент).
    </p>
    <p>
      Право использования предоставляется пользователям по подписке через сервис app.nedvex.ru.
    </p>
    <p>
      Сведения о включении ПО в Единый реестр российских программ для ЭВМ и баз данных: в процессе
      регистрации.
    </p>

    <hr />

    <h2>3. Назначение программного обеспечения</h2>

    <p>
      Программное обеспечение «Nedvex App» предназначено для автоматизации работы с объектами
      недвижимости. Система позволяет эффективно управлять данными об объектах, упрощает
      взаимодействие между отделами продаж и агентами, а также обеспечивает актуальность информации
      для клиентов.
    </p>

    <hr />

    <h2>4. Функциональные характеристики</h2>

    <ul>
      <li>
        Просмотр постоянно обновляемой информации об объектах недвижимости (адрес, стоимость,
        характеристики, фотографии и др.);
      </li>
      <li>
        Поиск и фильтрация объектов по множеству параметров (регион, район, стоимость, этап
        строительства, застройщик и др.);
      </li>
      <li>Формирование и сохранение подборок объектов;</li>
      <li>Выгрузка данных и подборок в формате PDF;</li>
      <li>
        Сортировка объектов по различным критериям (дате добавления, стоимости, популярности и др.);
      </li>
      <li>Актуализация и синхронизация данных между веб-версией и мобильным приложением.</li>
    </ul>

    <hr />

    <h2>5. Стоимость</h2>

    <p>
      Актуальная информация о тарифных планах и стоимости доступна по ссылке:{' '}
      <a href="https://app.nedvex.ru/rates" target="_blank" rel="noopener noreferrer">
        Тарифы
      </a>
    </p>
    <p>Для дополнительных вопросов о стоимости обращаться:</p>
    <ul>
      <li>Email: <a href="mailto:content@nedvexapp.ru">content@nedvexapp.ru</a></li>
      <li>Телефон: <a href="tel:+79683000112">+7 (968) 300-01-12</a></li>
    </ul>

    <hr />

    <h2>6. Технический стек</h2>

    <table>
      <tbody>
        <tr>
          <td>Веб-приложение</td>
          <td>React, TypeScript</td>
        </tr>
        <tr>
          <td>iOS-приложение</td>
          <td>Swift</td>
        </tr>
        <tr>
          <td>Android-приложение</td>
          <td>Kotlin</td>
        </tr>
        <tr>
          <td>Серверная часть</td>
          <td>PHP, Phalcon</td>
        </tr>
        <tr>
          <td>База данных</td>
          <td>MariaDB</td>
        </tr>
        <tr>
          <td>Хранение исходного кода</td>
          <td>Gitea (система контроля версий)</td>
        </tr>
      </tbody>
    </table>

    <p>
      Компиляция исходного текста не требуется — все компоненты написаны на интерпретируемых языках
      программирования.
    </p>

    <hr />

    <h2>7. Установка и запуск</h2>

    <p>
      ПО представляет собой интернет-сервис, дополнительных требований по установке программы со
      стороны пользователя не требуется.
    </p>
    <p>Ссылки для скачивания приложения:</p>
    <ul>
      <li>
        <a href="https://clck.ru/3GiqKd" target="_blank" rel="noopener noreferrer">
          App Store
        </a>
      </li>
      <li>
        <a href="https://clck.ru/3GiqBr" target="_blank" rel="noopener noreferrer">
          Google Play
        </a>
      </li>
      <li>
        <a href="https://app.nedvex.ru/" target="_blank" rel="noopener noreferrer">
          Веб-версия
        </a>
      </li>
    </ul>

    <hr />

    <h2>8. Руководство пользователя</h2>

    <ul>
      <li>
        <a href={manualMobile} target="_blank" rel="noopener noreferrer">
          Руководство пользователя (mobile)
        </a>
      </li>
      <li>
        <a href={manualWeb} target="_blank" rel="noopener noreferrer">
          Руководство пользователя (web)
        </a>
      </li>
    </ul>
  </div>
);

export default AboutProject;



// WEBPACK FOOTER //
// ./src/containers/Landing/AboutProject.jsx